import { Directive, ElementRef, Renderer2, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[invalidFile]'
})
export class InvalidFile implements OnChanges {
  acceptedFileTypes: string[] = ['image/jpg', 'image/jpeg', 'image/png', 'image/pdf', 'application/pdf'];

  @Input() file: File;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.file) {
      const filePreviewComponent = this.el.nativeElement;
      this.updateInvalidMessage(filePreviewComponent);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private updateInvalidMessage(filePreviewComponent: any) {
    const isInvalid = this.isFileTooBig(this.file) || this.isFileTypeDenied(this.file);
    this.renderer.setProperty(filePreviewComponent, 'invalid', isInvalid);

    if (isInvalid) {
      this.renderer.setProperty(filePreviewComponent, 'invalidMessage', this.getErrorMessage(this.file));
    }
  }

  isFileTooBig(file: File): boolean {
    return file.size > 2000000;
  }

  isFileTypeDenied(file: File): boolean {
    return !this.acceptedFileTypes.includes(file.type);
  }

  getErrorMessage(file: File): string {
    let message = '';
    const tooBig = this.isFileTooBig(file);
    const denied = this.isFileTypeDenied(file);

    if (tooBig && denied) {
      message = 'File too big. File type denied';
    } else if (tooBig) {
      message =  'File too big';
    } else {
      message =  'File type denied';
    }

    return message;
  }
}
